import api from '@/api/api'
import type { Contractor } from '@/types/Contractors'

export async function getCurrentContractor() {
  const { status, data } = await api.get<Contractor>('contractors/current')
  return status === 200 ? data : null
}
